import NoInlineResultSearcher from "./NoInlineResultSearchers"

class OACSearcher extends NoInlineResultSearcher {
    key = 'oac';
    searcherName = 'Unified catalog of California Archives';
    infoText = 'Unified catalog of California Archives';
    typeFilter2urlSection = {"All types" : null,
                             'Manuscripts' : null}
    multiTypeFilterSupported = false;
    dateFilterSupported = false;
    iframeSupported = true;

    fillTargetWebsiteUrl(value, store) { 
        this.targetWebsiteUrl = "https://oac.cdlib.org/search?query=" +
        encodeURIComponent(value);

    }
}

class HuntingtonSearcher extends NoInlineResultSearcher {
    key = 'huntigton';
    searcherName = 'Huntigton library digital collection';
    infoText = 'Huntigton library digital collection';
    typeFilter2urlSection =  {"All types" : {suffix : ""},
                                "Images": {suffix : "p15150coll2!p9539coll1!p16003coll7!p15150coll5"},
                                'Manuscripts' : {suffix : "p15150coll7!p16003coll11!p16003coll17!p16003coll2!p16003coll6"},
                                'Maps' : {suffix : "p15150coll4"},

                                }
    multiTypeFilterSupported = true;
    dateFilterSupported = true;
    iframeSupported = false;

    fillTargetWebsiteUrl(value, store) { 
        
        this.targetWebsiteUrl = "https://hdl.huntington.org/digital/search/searchterm/" +
        encodeURIComponent(value) +
        (store.searchInput.dates === null ? "" : "!" + store.searchInput.dates[0] + "-" + store.searchInput.dates[1] + "/field/all!date/mode/all!exact/conn/and!and") + 
        "/collection/" + 
        store.searchInput.selectedTypes.map(i => this.typeFilter2urlSection[i]['suffix']).join("!")

    }
}

class AvalonSearcher extends NoInlineResultSearcher {
    key = 'avalon';
    searcherName = "Yale's avalon project (historical documents in law, history and diplomacy)";
    infoText = "Yale's avalon project (historical documents in law, history and diplomacy)";
    typeFilter2urlSection = {"All types": null};
    multiTypeFilterSupported = false;
    dateFilterSupported = false;
    iframeSupported = false;

    fillTargetWebsiteUrl(value, store) { 
        this.targetWebsiteUrl = "https://www.google.com/search?domains=yale.edu&sitesearch=avalon.law.yale.edu%2F&q=" +
        encodeURIComponent(value);

    }
}


export {OACSearcher, HuntingtonSearcher, AvalonSearcher}